import React from 'react'


const PanelX1 = props => {

	const {
		children,
		className="",
		title
	} = props

	return (
		<div className={`panel_x1 ${className}`}>
			<div className="_head">
				<h5 className="_title">{title}</h5>
			</div>
			<div className="_body">
				{children}
			</div>
		</div>
	)

}


export default PanelX1
